export default {
  FileNameType: {
    icp: 'Oil ICP',
    ir: 'Oil IR',
    oe4: 'OE4 IR',
    particleCount: 'Oil Particle Count',
    viscosity: 'Oil Viscosity'
  }
};
